// useUserTracking.js
import { useEffect } from 'react';
import posthog from 'posthog-js';

export function useUserTracking(maxMoves = 5) {
  useEffect(() => {
    // --- Mouse Move Tracking ---
    let moveCount = 0;

    const handleMove = () => {
      moveCount++;
      posthog.capture("human_mousemove", {
        $useragent: navigator.userAgent
      });

      if (moveCount >= maxMoves) {
        document.removeEventListener("mousemove", handleMove);
      }
    };

    document.addEventListener("mousemove", handleMove);

    // --- Page Stay Duration ---
    const startTime = Date.now();

    const handleUnload = () => {
      const durationSeconds = Math.round((Date.now() - startTime) / 1000);
      posthog.capture("page_stay_duration", {
        seconds: durationSeconds,
        $useragent: navigator.userAgent
      });
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      window.removeEventListener("beforeunload", handleUnload);
      handleUnload(); // optional: capture if component unmounts early (like route change)
    };
  }, [maxMoves]);
}
